import React from 'react';
import { 
  FaHistory, 
  FaGift, 
  FaUserGraduate, 
  FaVideo, 
  FaUsers, 
  FaGlobeAmericas, 
  FaCertificate, 
  FaRegClock 
} from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaHistory className="why-choose-us__card-icon-svg" />,
      title: 'Founded in 2013',
      content: 'With years of experience in holy Quran teaching online, we’ve built a trusted learning environment focused on quality instruction, personalized support, and helping students develop practical Arabic skills with confidence.'
    },
    {
      icon: <FaGift className="why-choose-us__card-icon-svg" />,
      title: '3-Day Free Trial',
      content: 'Experience our teaching approach with a 3-day free trial before committing. Explore live lessons, meet your tutor, and see how personalized Arabic instruction fits your learning goals.'
    },
    {
      icon: <FaUserGraduate className="why-choose-us__card-icon-svg" />,
      title: 'Certified Arabic-Speaking Tutors',
      content: 'Learn from certified Arabic-speaking tutors who combine language expertise with effective teaching methods. Each tutor is focused on making lessons clear, engaging, practical, and designed to your needs.'
    },
    {
      icon: <FaVideo className="why-choose-us__card-icon-svg" />,
      title: '100% Live 1-on-1 Sessions',
      content: "Each lesson will be held online and will be one-to-one so you can have your tutor's undivided attention. You will be able to ask any questions, practice conversation, get quick feedback, and move at your own pace."
    },
    {
      icon: <FaUsers className="why-choose-us__card-icon-svg" />,
      title: 'Male and Female Tutors',
      content: (
        <>
          Choose from our male and female tutors according to your preferences and learning needs. Find a tutor that you feel comfortable studying with. <a className="why-choose-us__link" href="/free-trial/">Get a free trial now.</a>
        </>
      )
    },
    {
      icon: <FaGlobeAmericas className="why-choose-us__card-icon-svg" />,
      title: 'Scheduling in Every US Time Zone',
      content: 'Schedule lessons around your routine with flexible availability across every US time zone. Whether you prefer morning, afternoon, or evening sessions, finding a convenient lesson time is simple.'
    },
    {
      icon: <FaCertificate className="why-choose-us__card-icon-svg" />,
      title: 'Certification After Completion',
      content: 'Receive a certificate after completing your course. Your certificate recognizes your commitment to learning and provides a record of your completed Arabic education and training.'
    },
    {
      icon: <FaRegClock className="why-choose-us__card-icon-svg" />,
      title: 'Flexible Timings',
      content: 'Choose lesson times that fit your schedule and daily routine. Our flexible scheduling options make it easier to attend live Arabic sessions without disrupting work, school, or personal commitments.'
    }
  ];

  return (
    <section
      className="why-choose-us"
      id="why-choose-us"
      style={{
        '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
      }}
    >
      <div className="why-choose-us__container">
        {/* Section Headings */}
        <div className="why-choose-us__header">
          <h2 className="why-choose-us__title">
            Why Families Keep Choosing Al Quran Lesson for Online Quran Classes
          </h2>
          <p className="why-choose-us__subtitle">
            Online Quran academies aren't hard to find. What's harder to find is one that's been doing this long enough, and carefully enough, to actually earn trust:
          </p>
        </div>

        {/* Features Card Grid */}
        <div className="why-choose-us__grid">
          {features.map((item, index) => (
            <div className="why-choose-us__card" key={index}>
              <div className="why-choose-us__card-header">
                <div className="why-choose-us__icon-box">
                  {item.icon}
                </div>
                <h3 className="why-choose-us__card-title">{item.title}</h3>
              </div>
              <p className="why-choose-us__card-content">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;


